import { useToast } from '@jaymathew/ui-shared/contexts/ToastContext'
import { useQuery } from '@tanstack/react-query'
import getUserQueryOptions, { GetUserOptions} from 'queryOptions/getUser'
import { AllowedOverrides } from 'queryOptions/queryOptionsUtils.types'

interface UseGetUserParams {
	params: GetUserOptions
	overrides?: AllowedOverrides
}

export const useGetUser = ({ params, overrides }: UseGetUserParams) => {
	const { triggerToast } = useToast()

	const queryResult = useQuery(
		getUserQueryOptions(params, overrides),
	)

	if (queryResult.error) {
		triggerToast(`Error fetching user: ${queryResult.error.message}`, 'error')
	}

	return {
		...queryResult,
		user: queryResult.data,
	}
}
